/** @format */

import { Container } from "../../components/layouts/Container";
import { DashboardBarElement, DashboardMessageElement, DashboardLowerWrapper } from "../../components/ui_elements";
import OcnkTeikiDashboardBoxElement from "../../components/ui_elements/ocnkTeiki/Dashboard/DashboardBoxElement";
import useDashboardHooks from "../../hooks/useDashboardHooks";
import ErrorBoundary from "../../api/ErrorBoundary";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";
import usePdfDownloadHooks from "../../hooks/usePdfDownloadHooks";

const DashBoard = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const { pdfDownloadHandler } = usePdfDownloadHooks();
  const {
    status,
    beforeStatus,
    step,
    errorStep,
    buttonPhrase,
    canceledFlag,
    mainMessage,
    moveToStart,
    moveToUseStart,
    moveToExamination,
    moveToUseStartPrecautions,
  } = useDashboardHooks(navigateByAgent);

  const background = "white";
  const align = "top";
  const fullwidth = true;

  return (
    <ErrorBoundary>
      <Container background={background} align={align} fullwidth={fullwidth} isLogin isInquiry>
        <DashboardMessageElement mainMessage={mainMessage} step={step} />
        <DashboardLowerWrapper>
          <OcnkTeikiDashboardBoxElement
            status={status}
            step={step}
            errorStep={errorStep}
            buttonPhrase={buttonPhrase}
            canceledFlag={canceledFlag}
            moveToStart={moveToStart}
            moveToUseStart={moveToUseStart}
            moveToExamination={moveToExamination}
            moveToUseStartPrecautions={moveToUseStartPrecautions}
          />
          <DashboardBarElement
            pdfDownloadHandler={pdfDownloadHandler}
            userStatus={status}
            beforeStatus={beforeStatus}
          />
        </DashboardLowerWrapper>
      </Container>
    </ErrorBoundary>
  );
};

export default DashBoard;
